module.exports = __webpack_public_path__ + "img/goods_coupon_chiba04_used.fa5b4dd8.png";